module.exports = __webpack_public_path__ + "static/media/FiveStars.5bdd0835.png";